<template>
  <div class="checkout__wrapper">
    <h3 class="h5 mb-5">Selecione a forma de pagamento</h3>
    <div class="recharge__wrapper">
      <div class="recharge__item" @click="$emit('setPaymentType', 'ASAAS_CREDIT_CARD')">
        <v-icon>
          mdi-credit-card-outline
        </v-icon>
        <h2 class="mt-3">
          <span class="d-block caption">
            {{ $t('quote.modal.payWith') }}
          </span>
          <span class="font-weight-bold">
            {{ $t('quote.modal.creditCard') }}
          </span>
        </h2>
        <div class="mw-200 mx-auto">
          <v-divider class="my-3 grey lighten-3" />
          <h6 class="d-block body-2 grey--text">
            {{ $t('recharge.paymentInfo.credit') }}
          </h6>
        </div>
      </div>
      <div class="recharge__item" @click="$emit('setPaymentType', 'ASAAS_PIX')">
        <PixIcon width="50" height="57" opacity="0.1" />
        <h2 class="mt-3">
          <span class="d-block caption">
            {{ $t('quote.modal.payWith') }}
          </span>
          <span class="font-weight-bold">
            {{ $t('quote.modal.pix') }}
          </span>
        </h2>
        <div class="mw-200 mx-auto">
          <v-divider class="my-3 grey lighten-3" />
          <h6 class="d-block body-2 grey--text">
            {{ $t('recharge.paymentInfo.pix') }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PixIcon from '@/components/icons/Pix'
import logo from '@/assets/images/logohauseful.svg'

export default {
  name: 'CheckoutPaymentType',

  props: {
    paymentType: {
      type: String,
    },
  },

  components: {
    PixIcon,
  },

  data() {
    return {
      logo,
    }
  },
}
</script>
